import styled from "@emotion/styled";

export const TradeDetailsButton = styled.button`
  background: transparent;
  color: ${props => props.theme.font.primary.default};
  font-size: ${props => props.theme.fontSize[5]};
  border: none;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
`;
